'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.CssDevice = void 0;
var CssDevice;
(function (CssDevice) {
    CssDevice["MOBILE"] = "mobile";
    CssDevice["PHABLET"] = "phablet";
    CssDevice["TABLET"] = "tablet";
    CssDevice["DESKTOP"] = "desktop";
    CssDevice["LARGE"] = "large";
})(CssDevice = exports.CssDevice || (exports.CssDevice = {}));
